import { define, auto } from 'type-r'
import { restfulIO } from 'type-r/endpoints/restful'
import { store } from '../models/store.js'
import View from './view.js'

@define
export default class ChartView extends View {
    static endpoint = restfulIO('/json');

    @auto(0) declare mindt: number
    @auto(0) declare maxdt: number
    @auto([]) declare dd: any[]

    private _ro: ResizeObserver | null = null;

    initialize() {
        this.listenTo(store, "change:currdt", this.onNewData);
        this.listenTo(store, "change:selCpn", this.onChangeCpn);
        this.listenTo(store, "change:choice", this.onChoiceChange);

        const parent = $(this.el).parent().get(0);
        if (parent) {
            this._ro = new ResizeObserver(() => this.onContainerResize());
            this._ro.observe(parent);
        }
    }

    private onContainerResize(): void {
        if (!this.visible) return;
        this.sizeToParent();
        this.onResized();
    }

    private sizeToParent(): void {
        const p = $(this.el).parent();
        $(this.el).width(p.width()!);
        $(this.el).height(p.height()!);
    }

    parse(data?: any) {
        data = super.parse(data);
        if (data?.extras) {
            this.trigger("extras", data.extras);
            delete data.extras;
        }
        if (data?.data) {
            data = data.data;
        }
        if (data?.caption) {
            this.trigger("caption", data.caption);
            delete data.caption;
        }
        if (data?.rr) {
            store.rr = data.rr;
            delete data.rr;
        } else {
            store.rr = null;
        }
        return this.parseExtra(data);
    }

    show() {
        $(this.el).show();
        this.sizeToParent();
        this.onShow();
    }

    hide() {
        $(this.el).hide();
    }

    async onChangeCpn(val: string): Promise<void> {
        if (!this.visible) return;
        this.onCpnChanging();
        await this.fetch();
    }

    async onNewData() {
        if (this.visible) {
            await this.fetch();
        }
    }

    async onChoiceChange() {
        if (store.choice === this.choiceValue && !this.visible) {
            this.show();
            await this.fetch();
        } else if (store.choice !== this.choiceValue && this.visible) {
            this.hide();
        }
    }

    fetch(opts?: any) {
        return super.fetch({ params: { ...this.fetchParams(), ...opts?.params } });
    }

    // ---- Subclass hooks ----

    protected get choiceValue(): number {
        return -1;
    }

    protected onResized(): void {}

    protected onShow(): void {}

    protected onCpnChanging(): void {}

    protected parseExtra(data?: any): any {
        return data;
    }

    protected fetchParams(): Record<string, any> {
        return { dt: store.currdt, idx: 0, cpn: store.selCpn };
    }
}
